import { Controller } from 'stimulus';

// Card checkboxes + the bulk bar on the Templates screen (Mark inactive /
// Mark active in bulk). Two selection modes:
//
//   explicit      the boxes ticked on the page; the form posts ids[]
//   all matching  every template the current filters would list, across
//                 pages; the form posts all_matching=1 and the server
//                 re-resolves the same filters. Entered from the bar's
//                 "Select all N" link or the idle banner (?select=all).
//                 Unticking any card drops back to explicit.
//
// Cards appended by infinite scroll are absorbed (ticked when everything
// is selected) through a MutationObserver on the list.
export default class extends Controller {
  static targets = ['box', 'bar', 'count', 'scopeNote', 'allLink', 'allMatching', 'ids',
                    'deactivate', 'activate', 'list'];

  connect() {
    this.total = Number(this.data.get('total') || 0);
    this.allMatching = this.data.get('preselect') === 'all' && this.total > 0;
    if (this.allMatching) this.boxTargets.forEach((box) => { box.checked = true; });
    if (this.hasListTarget) {
      this.observer = new MutationObserver(() => this.absorbNewCards());
      this.observer.observe(this.listTarget, { childList: true });
    }
    this.refresh();
  }

  disconnect() {
    if (this.observer) this.observer.disconnect();
  }

  absorbNewCards() {
    if (this.allMatching) this.boxTargets.forEach((box) => { box.checked = true; });
    this.refresh();
  }

  toggle(event) {
    if (this.allMatching && !event.target.checked) this.allMatching = false;
    this.refresh();
  }

  selectAllMatching(event) {
    if (event) event.preventDefault();
    this.allMatching = true;
    this.boxTargets.forEach((box) => { box.checked = true; });
    this.refresh();
  }

  clear(event) {
    if (event) event.preventDefault();
    this.allMatching = false;
    this.boxTargets.forEach((box) => { box.checked = false; });
    this.refresh();
  }

  refresh() {
    if (!this.hasBarTarget) return;
    const checked = this.boxTargets.filter((box) => box.checked);
    const n = this.allMatching ? this.total : checked.length;
    const count = n.toLocaleString();
    const noun = n === 1 ? 'template' : 'templates';

    this.barTarget.classList.toggle('is-hidden', n === 0);
    this.boxTargets.forEach((box) => {
      const card = box.closest('.ti-tplcard');
      if (card) card.classList.toggle('is-selected', box.checked);
    });

    this.countTarget.textContent = `${count} selected`;
    if (this.hasScopeNoteTarget) {
      this.scopeNoteTarget.textContent = this.allMatching ? '· every template on this list' : '';
    }
    if (this.hasAllLinkTarget) {
      this.allLinkTarget.classList.toggle('is-hidden', this.allMatching || checked.length >= this.total);
    }

    this.allMatchingTarget.value = this.allMatching ? '1' : '';
    this.idsTarget.innerHTML = '';
    if (!this.allMatching) {
      checked.forEach((box) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'ids[]';
        input.value = box.value;
        this.idsTarget.appendChild(input);
      });
    }

    if (this.hasDeactivateTarget) {
      this.deactivateTarget.textContent = `Mark ${count} inactive`;
      this.deactivateTarget.dataset.confirm =
        `Mark ${count} ${noun} inactive? They stay on this screen behind Include inactive, `
        + 'stop being offered in template pickers, and can be turned back on any time.';
    }
    if (this.hasActivateTarget) {
      this.activateTarget.textContent = `Mark ${count} active`;
    }
  }
}
